import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import style from './CanvasDraw.module.css';
import classNames from 'classnames/bind';
import iconSrc from "../../../../assets/images/position_car_park.svg";
import { Image as ImageAntd} from 'antd';
const cx = classNames.bind(style);
const width = 640;
const height = 360;

function CanvasDraw({ polygon, preview }) {
    const canvasRef = useRef(null);
    const [canvas, setCanvas] = useState(null);
    const [restore, setReStore] = useState(false);
    useEffect(() => {
        if (canvasRef.current) {
            setCanvas(canvasRef?.current);
            const ctx = canvasRef?.current?.getContext("2d");
            ctx.clearRect(0, 0, canvasRef?.current?.width, canvasRef?.current?.height);
        }
    }, [canvasRef]);

    const drawPosition = (ctx, x, y) => {
        const icon = new Image();
        icon.src = iconSrc;
        icon.onload = () => {
            ctx.drawImage(icon, x - 8, y - 8, 28, 28);
            ctx.drawImage(icon, x - 8, y - 8, 28, 28);
        };
    };

    const drawPolygon = (ctx, lines) => {
        let xa, ya, xb, yb, x3, y3, x4, y4;
        lines.forEach((item, index) => {
            if (index === 0) {
                xa = item[0] * width / polygon?.width;
                ya = item[1] * height / polygon?.height;
            } else if (index === 1) {
                xb = item[0] * width / polygon?.width;
                yb = item[1] * height / polygon?.height;
            } else if (index === 2) {
                x3 = item[0] * width / polygon?.width;
                y3 = item[1] * height / polygon?.height;
            } else if (index === 3) {
                x4 = item[0] * width / polygon?.width;
                y4 = item[1] * height / polygon?.height;
            }
        });
        // Bắt đầu vẽ hình tứ giác
        ctx.beginPath();
        ctx.moveTo(xa, ya);
        ctx.lineTo(xb, yb);
        ctx.lineTo(x3, y3);
        ctx.lineTo(x4, y4);
        ctx.closePath();
        // Vẽ stroke
        ctx.lineWidth = 2;
        ctx.strokeStyle = "white";
        ctx.stroke();
        // Thiết lập màu và tô màu nền cho hình tứ giác
        ctx.fillStyle = 'rgba(0, 64, 255, 0.04)';
        ctx.fill();
    };

    useEffect(() => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const points = polygon?.pointList;
            points?.forEach((reg) => {
                drawPosition(ctx, reg[0] * width / polygon?.width, reg[1] * height / polygon?.height)
            })
        }
    }, [polygon?.pointList])

    useEffect(() => {
        if (canvas) {

            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const region = polygon?.polygon;
            region?.forEach((reg) => {
                drawPolygon(ctx, reg);
            })
        }
    }, [canvas, polygon?.polygon])

    useMemo(() => {
        if (restore && canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
            setReStore(false);
        }
        if (polygon?.polygon1?.length === 0 && canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
        }
    }, [polygon, restore, canvas])

    useLayoutEffect(() => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            const rect = canvas.getBoundingClientRect();
            const dpr = window.devicePixelRatio;
            canvas.width = width;
            canvas.height = height;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [canvas]);


    return (
        <div className={cx('box-video')} style={{ width: `${width}px`, height: `${height}px` }}>
            <ImageAntd
                style={{ width: `${width}px`, height: `${height}px` }}
                src={polygon?.path}
                preview={{
                    imageRender: (originalNode) => {
                        const image = {
                            ...originalNode,
                            props: {
                                ...originalNode.props,
                                style: {
                                    ...originalNode.props.style,
                                    minHeight: `${500}px`
                                }
                            }
                        }
                        return image;
                    }
                }}
                alt='Car Park'
            />
            {!preview && (
                <canvas
                    ref={canvasRef}
                    className={cx('canvas-space')}
                    style={{ width: `${width}px`, height: `${height}px` }}
                />
            )}
        </div>
    )
}

export default CanvasDraw;